import React from "react";
import { styled } from "@mui/material/styles";

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";

const ExpandMore = styled(
    React.forwardRef(({ expand, ...other }, ref) => (
      <IconButton {...other} ref={ref} />
    ))
  )(({ theme, expand }) => ({
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
    transform: expand ? "rotate(180deg)" : "rotate(0deg)",
  }));

export default function ExpandButton({ expanded, handleExpandClick }) {
  const { t } = useTranslation();
  return (
    <div>
      <Tooltip title={t("common.buttons.more")}>
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </ExpandMore>
      </Tooltip>
    </div>
  );
}
